var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path84, _path85, _path86, _path87, _path88, _path89, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path90, _path91, _path92, _path93, _ellipse13, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarbleWorld = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1201,
    height: 800,
    viewBox: "0 0 1201 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.725586,
    width: 1200,
    height: 800,
    fill: "#BCDACF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M862.516 473.397L819.838 494.308L862.516 517.038L905.193 494.308L862.516 473.397Z",
    fill: "#A4D0DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M905.196 450.718L862.622 473.51L905.196 494.478L947.769 471.686L905.196 450.718Z",
    fill: "#A4D0DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M905.192 494.309L862.515 517.038V543.405L905.192 520.675V494.309Z",
    fill: "#33717F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M947.87 471.579L905.193 494.309V520.675L947.87 497.945V471.579Z",
    fill: "#33717F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M819.838 494.309L862.515 517.038V543.405L819.838 520.675V494.309Z",
    fill: "#5CBCD1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M862.516 446.122L819.838 467.033L862.516 489.763L905.193 467.033L862.516 446.122Z",
    fill: "#A4D0DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M905.196 423.443L862.622 446.234L905.196 467.202L947.769 444.411L905.196 423.443Z",
    fill: "#A4D0DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M905.192 467.034L862.515 489.763V516.13L905.192 493.4V467.034Z",
    fill: "#33717F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M947.87 444.304L905.193 467.034V493.4L947.87 470.67V444.304Z",
    fill: "#33717F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M819.838 467.034L862.515 489.763V516.13L819.838 493.4V467.034Z",
    fill: "#5CBCD1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M820.809 497.035L863.486 517.946L820.809 540.676L778.131 517.946L820.809 497.035Z",
    fill: "#F3988B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M778.131 517.947L820.808 540.676V567.043L778.131 544.313V517.947Z",
    fill: "#EA7362"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M863.486 517.947L820.809 540.676V567.043L863.486 544.313V517.947Z",
    fill: "#C13925"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M778.128 474.356L820.701 497.147L778.128 518.115L735.554 495.324L778.128 474.356Z",
    fill: "#F3988B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M735.453 495.218L778.131 517.947V544.313L735.453 521.584V495.218Z",
    fill: "#EA7362"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.758 721.591L94.0803 744.32V770.686L136.758 747.957V721.591Z",
    fill: "#C13925"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9159 700.76L51.4016 678L8.82812 698.968L51.4016 721.759L51.5675 721.678L94.0805 744.319L136.758 721.59L94.0805 700.679L93.9159 700.76Z",
    fill: "#F3988B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4031 721.591L8.72559 698.861V725.227L51.4031 747.957V721.591ZM94.0808 744.32L51.4033 721.591V747.957L94.0808 770.686V744.32Z",
    fill: "#EA7362"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M777.161 447.085L819.735 468.053L777.161 490.844L734.588 468.053L777.161 447.085Z",
    fill: "#F3988B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M734.483 467.943L777.161 490.673V517.039L734.483 494.309V467.943Z",
    fill: "#EA7362"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M819.838 467.943L777.16 490.673V517.039L819.838 494.309V467.943Z",
    fill: "#C13925"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M948.403 473.145L990.977 494.113L948.403 516.904L905.83 494.113L948.403 473.145Z",
    fill: "#6DD6B0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M905.726 494.003L948.403 516.733V543.099L905.726 520.37V494.003Z",
    fill: "#52BDA4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M991.08 494.003L948.403 516.733V543.099L991.08 520.37V494.003Z",
    fill: "#338177"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.4 701.145L1189.98 722.113L1147.4 744.904L1104.83 722.113L1147.4 701.145Z",
    fill: "#6DD6B0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.73 722.003L1147.4 744.733V771.099L1104.73 748.37V722.003Z",
    fill: "#52BDA4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.08 722.003L1147.4 744.733V771.099L1190.08 748.37V722.003Z",
    fill: "#338177"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M948.841 445.265L991.414 466.233L948.841 489.025L906.267 466.233L948.841 445.265Z",
    fill: "#6DD6B0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M906.163 466.124L948.841 488.853V515.219L906.163 492.49V466.124Z",
    fill: "#52BDA4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M991.518 466.124L948.84 488.853V515.219L991.518 492.49V466.124Z",
    fill: "#338177"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M905.193 438.85L862.516 461.579V487.945L905.193 465.216V438.85Z",
    fill: "#D37D12"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M819.838 438.85L862.515 461.579V487.945L819.838 465.216V438.85Z",
    fill: "#F1AE5B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.68 418.019L905.195 395.259L947.769 416.227L905.195 439.018L905.03 438.937L862.516 461.579L819.839 438.849L862.516 417.938L862.68 418.019Z",
    fill: "#F5C58A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M947.871 416.12L905.194 438.849V465.215L947.871 442.486V416.12Z",
    fill: "#D37D12"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M819.727 539.824L862.404 562.553V588.919L819.727 566.19V539.824Z",
    fill: "#F1AE5B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.568 518.993L905.084 496.233L947.657 517.201L905.084 539.992L904.918 539.91L862.403 562.553L819.725 539.824L862.403 518.913L862.568 518.993Z",
    fill: "#F5C58A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M905.081 539.824L947.759 517.094V543.461L905.081 566.19V539.824ZM862.404 562.553L905.081 539.824V566.19L862.404 588.919V562.553Z",
    fill: "#D37D12"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M948.841 417.081L991.414 438.049L948.841 460.84L906.267 438.049L948.841 417.081Z",
    fill: "#A4D0DA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M906.163 437.94L948.841 460.669V487.035L906.163 464.306V437.94Z",
    fill: "#5CBCD1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M991.518 437.94L948.84 460.669V487.035L991.518 464.306V437.94Z",
    fill: "#33717F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M949.403 388.46L991.977 409.428L949.403 432.219L906.83 409.428L949.403 388.46Z",
    fill: "#D0AFC8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M906.726 409.318L949.403 432.048V458.414L906.726 435.684V409.318Z",
    fill: "#AA6F9C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M992.08 409.318L949.403 432.048V458.414L992.08 435.684V409.318Z",
    fill: "#704265"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M137.403 722.5L179.977 745.113L137.403 767.904L94.8299 745.113L137.403 722.5Z",
    fill: "#D0AFC8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7256 745.003L137.403 767.733V794.099L94.7256 771.369V745.003Z",
    fill: "#AA6F9C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M180.08 745.003L137.403 767.733V794.099L180.08 771.369V745.003Z",
    fill: "#704265"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M949.403 359.402L991.977 380.37L949.403 403.162L906.83 380.37L949.403 359.402Z",
    fill: "#D0AFC8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M906.726 380.261L949.403 402.99V429.356L906.726 406.627V380.261Z",
    fill: "#AA6F9C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M992.08 380.261L949.403 402.99V429.356L992.08 406.627V380.261Z",
    fill: "#704265"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M449.501 702.73L492.074 723.698L449.501 746.489L406.928 723.698L449.501 702.73Z",
    fill: "#D0AFC8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M406.823 723.588L449.501 746.318V772.684L406.823 749.955V723.588Z",
    fill: "#AA6F9C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M492.178 723.588L449.5 746.318V772.684L492.178 749.955V723.588Z",
    fill: "#704265"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 330.728L992.106 351.696L949.532 374.487L906.959 351.696L949.532 330.728Z",
    fill: "#D0AFC8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M906.854 351.587L949.532 374.316V400.682L906.854 377.953V351.587Z",
    fill: "#AA6F9C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M992.209 351.587L949.531 374.316V400.682L992.209 377.953V351.587Z",
    fill: "#704265"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M449.501 674.546L492.074 695.514L449.501 718.305L406.928 695.514L449.501 674.546Z",
    fill: "#D0AFC8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M406.823 695.404L449.501 718.134V744.5L406.823 721.77V695.404Z",
    fill: "#AA6F9C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M492.178 695.404L449.5 718.134V744.5L492.178 721.77V695.404Z",
    fill: "#704265"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M733.514 497.945L776.191 518.856L733.514 541.585L690.836 518.856L733.514 497.945Z",
    fill: "#F5C58A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M690.836 518.856L733.513 541.586V567.952L690.836 545.222V518.856Z",
    fill: "#F1AE5B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M776.191 518.856L733.514 541.586V567.952L776.191 545.222V518.856Z",
    fill: "#D37D12"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M690.833 475.265L733.406 498.057L690.833 519.025L648.259 496.233L690.833 475.265Z",
    fill: "#F5C58A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M648.158 496.126L690.836 518.856V545.222L648.158 522.493V496.126Z",
    fill: "#F1AE5B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M688.896 521.583L731.574 542.494L688.896 565.224L646.219 542.494L688.896 521.583Z",
    fill: "#F5C58A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M731.574 542.495L688.897 565.225V591.591L731.574 568.861V542.495Z",
    fill: "#D37D12"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M646.216 498.904L688.789 521.695L646.216 542.663L603.642 519.872L646.216 498.904Z",
    fill: "#F5C58A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.219 542.495L603.541 519.766V546.132L646.219 568.861V542.495ZM688.896 565.224L646.219 542.495V568.861L688.896 591.591V565.224Z",
    fill: "#F1AE5B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.76 745.824L1104.08 768.554V794.92L1146.76 772.19V745.824Z",
    fill: "#D37D12"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.92 724.993L1061.4 702.233L1018.83 723.201L1061.4 745.992L1061.57 745.91L1104.08 768.553L1146.76 745.824L1104.08 724.913L1103.92 724.993Z",
    fill: "#F5C58A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.4 745.824L1018.73 723.095V749.461L1061.4 772.19V745.824ZM1104.08 768.553L1061.4 745.824V772.19L1104.08 794.919V768.553Z",
    fill: "#F1AE5B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M733.514 469.76L776.191 490.671L733.514 513.401L690.836 490.671L733.514 469.76Z",
    fill: "#6DD6B0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M690.833 447.081L733.406 469.872L690.833 490.84L648.259 468.049L690.833 447.081Z",
    fill: "#6DD6B0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M690.836 490.672L733.513 513.401V539.768L690.836 517.038V490.672Z",
    fill: "#52BDA4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M648.158 467.943L690.836 490.672V517.038L648.158 494.309V467.943Z",
    fill: "#52BDA4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M776.191 490.672L733.514 513.401V539.768L776.191 517.038V490.672Z",
    fill: "#338177"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M762.612 487.945C762.612 485.434 759.138 483.399 754.852 483.399C750.567 483.399 747.093 485.434 747.093 487.945V493.4C747.093 495.91 750.567 497.946 754.852 497.946C759.138 497.946 762.612 495.91 762.612 493.4V487.945Z",
    fill: "#338077"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M719.934 465.216C719.934 462.705 716.46 460.67 712.175 460.67C707.889 460.67 704.415 462.705 704.415 465.216V470.671C704.415 473.181 707.889 475.217 712.175 475.217C716.46 475.217 719.934 473.181 719.934 470.671V465.216Z",
    fill: "#338077"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M719.934 487.945C719.934 485.434 716.46 483.399 712.175 483.399C707.889 483.399 704.415 485.434 704.415 487.945V493.4C704.415 495.91 707.889 497.946 712.175 497.946C716.46 497.946 719.934 495.91 719.934 493.4V487.945Z",
    fill: "#338077"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M677.256 465.216C677.256 462.705 673.782 460.67 669.497 460.67C665.211 460.67 661.737 462.705 661.737 465.216V470.671C661.737 473.181 665.211 475.217 669.497 475.217C673.782 475.217 677.256 473.181 677.256 470.671V465.216Z",
    fill: "#338077"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M741.273 498.855C741.273 496.344 737.799 494.309 733.513 494.309C729.228 494.309 725.754 496.344 725.754 498.855V504.31C725.754 506.82 729.228 508.855 733.513 508.855C737.799 508.855 741.273 506.82 741.273 504.31V498.855Z",
    fill: "#338077"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M698.595 476.125C698.595 473.615 695.121 471.579 690.836 471.579C686.55 471.579 683.076 473.615 683.076 476.125V481.58C683.076 484.091 686.55 486.126 690.836 486.126C695.121 486.126 698.595 484.091 698.595 481.58V476.125Z",
    fill: "#338077"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M741.273 477.944C741.273 475.434 737.799 473.398 733.513 473.398C729.228 473.398 725.754 475.434 725.754 477.944V483.399C725.754 485.909 729.228 487.945 733.513 487.945C737.799 487.945 741.273 485.909 741.273 483.399V477.944Z",
    fill: "#338077"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M698.595 455.214C698.595 452.703 695.121 450.668 690.836 450.668C686.55 450.668 683.076 452.703 683.076 455.214V460.669C683.076 463.179 686.55 465.215 690.836 465.215C695.121 465.215 698.595 463.179 698.595 460.669V455.214Z",
    fill: "#338077"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 754.852,
    cy: 487.944,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 712.174,
    cy: 465.216,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 712.174,
    cy: 487.944,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 669.497,
    cy: 465.216,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 733.513,
    cy: 498.854,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.836,
    cy: 476.125,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 733.513,
    cy: 477.944,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.836,
    cy: 455.215,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.915 493.733L646.4 470.972L603.826 491.94L646.4 514.731L646.566 514.649L689.08 537.292L731.758 514.563L689.08 493.652L688.915 493.733Z",
    fill: "#6DD6B0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M646.403 514.563L603.726 491.833V518.2L646.403 540.929V514.563Z",
    fill: "#52BDA4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M689.081 537.293L646.403 514.563V540.929L689.081 563.659V537.293Z",
    fill: "#52BDA4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M731.758 514.563L689.08 537.293V563.659L731.758 540.929V514.563Z",
    fill: "#338177"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M718.179 511.836C718.179 509.325 714.705 507.29 710.42 507.29C706.134 507.29 702.66 509.325 702.66 511.836V517.291C702.66 519.801 706.134 521.836 710.42 521.836C714.705 521.836 718.179 519.801 718.179 517.291V511.836Z",
    fill: "#338077"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M675.502 489.107C675.502 486.596 672.027 484.561 667.742 484.561C663.457 484.561 659.982 486.596 659.982 489.107V494.562C659.982 497.072 663.457 499.108 667.742 499.108C672.027 499.108 675.502 497.072 675.502 494.562V489.107Z",
    fill: "#338077"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.419,
    cy: 511.836,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.742,
    cy: 489.106,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 689.081,
    cy: 501.835,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.403,
    cy: 479.106,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#6DD6B0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M753.882 431.656L796.455 452.624L753.882 475.416L711.308 452.624L753.882 431.656Z",
    fill: "#F5C58A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M711.204 452.515L753.882 475.244V501.61L711.204 478.881V452.515Z",
    fill: "#F1AE5B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M796.559 452.515L753.881 475.244V501.61L796.559 478.881V452.515Z",
    fill: "#D37D12"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M740.302 449.788C740.302 447.277 736.828 445.242 732.543 445.242C728.257 445.242 724.783 447.277 724.783 449.788V455.243C724.783 457.753 728.257 459.789 732.543 459.789C736.828 459.789 740.302 457.753 740.302 455.243V449.788Z",
    fill: "#D37D12"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 732.543,
    cy: 449.788,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F5C58A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M710.234 454.305L752.912 475.216L710.234 497.945L667.557 475.216L710.234 454.305Z",
    fill: "#A4D0DA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M667.555 431.625L710.129 454.416L667.555 475.384L624.982 452.593L667.555 431.625Z",
    fill: "#A4D0DA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.557 475.216L624.88 452.487V478.853L667.557 501.582V475.216ZM710.235 497.945L667.558 475.216V501.582L710.235 524.311V497.945Z",
    fill: "#5CBCD1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M752.912 475.216L710.235 497.945V524.311L752.912 501.582V475.216Z",
    fill: "#33717F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.07 426.201L667.555 403.441L624.981 424.409L667.555 447.2L667.722 447.118L710.236 469.76L752.913 447.031L710.236 426.12L710.07 426.201Z",
    fill: "#A4D0DA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.557 447.032L624.88 424.302V450.668L667.557 473.398V447.032ZM710.235 469.76L667.558 447.031V473.397L710.235 496.127V469.76Z",
    fill: "#5CBCD1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M752.912 447.031L710.235 469.76V496.127L752.912 473.397V447.031Z",
    fill: "#33717F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.916 729.074L793.401 706.313L750.827 727.281L793.401 750.073L793.567 749.991L836.081 772.633L878.759 749.904L836.081 728.993L835.916 729.074Z",
    fill: "#A4D0DA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M793.403 749.905L750.726 727.175V753.541L793.403 776.271V749.905ZM836.081 772.634L793.403 749.905V776.271L836.081 799V772.634Z",
    fill: "#5CBCD1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M878.758 749.905L836.08 772.634V799L878.758 776.271V749.905Z",
    fill: "#33717F"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 302.543L992.106 323.511L949.532 346.302L906.959 323.511L949.532 302.543Z",
    fill: "#F3988B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M906.854 323.402L949.532 346.131V372.497L906.854 349.768V323.402Z",
    fill: "#EA7362"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M992.209 323.402L949.531 346.131V372.497L992.209 349.768V323.402Z",
    fill: "#C13925"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M978.63 320.675C978.63 318.164 975.156 316.129 970.871 316.129C966.585 316.129 963.111 318.164 963.111 320.675V326.13C963.111 328.64 966.585 330.676 970.871 330.676C975.156 330.676 978.63 328.64 978.63 326.13V320.675Z",
    fill: "#C13925"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M935.953 320.675C935.953 318.164 932.479 316.129 928.193 316.129C923.908 316.129 920.434 318.164 920.434 320.675V326.13C920.434 328.64 923.908 330.676 928.193 330.676C932.479 330.676 935.953 328.64 935.953 326.13V320.675Z",
    fill: "#C13925"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M957.292 331.585C957.292 329.074 953.817 327.039 949.532 327.039C945.247 327.039 941.772 329.074 941.772 331.585V337.04C941.772 339.55 945.247 341.586 949.532 341.586C953.817 341.586 957.292 339.55 957.292 337.04V331.585Z",
    fill: "#C13925"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M957.292 310.674C957.292 308.164 953.817 306.128 949.532 306.128C945.247 306.128 941.772 308.164 941.772 310.674V316.129C941.772 318.64 945.247 320.675 949.532 320.675C953.817 320.675 957.292 318.64 957.292 316.129V310.674Z",
    fill: "#C13925"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 970.871,
    cy: 320.675,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 928.193,
    cy: 320.675,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.532,
    cy: 331.585,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.532,
    cy: 310.674,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 274.359L992.106 295.327L949.532 318.118L906.959 295.327L949.532 274.359Z",
    fill: "#F3988B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M906.854 295.218L949.532 317.947V344.313L906.854 321.584V295.218Z",
    fill: "#EA7362"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M992.209 295.218L949.531 317.947V344.313L992.209 321.584V295.218Z",
    fill: "#C13925"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M978.63 292.491C978.63 289.98 975.156 287.945 970.871 287.945C966.585 287.945 963.111 289.98 963.111 292.491V297.946C963.111 300.456 966.585 302.491 970.871 302.491C975.156 302.491 978.63 300.456 978.63 297.946V292.491Z",
    fill: "#C13925"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M935.953 292.491C935.953 289.98 932.479 287.945 928.193 287.945C923.908 287.945 920.434 289.98 920.434 292.491V297.946C920.434 300.456 923.908 302.491 928.193 302.491C932.479 302.491 935.953 300.456 935.953 297.946V292.491Z",
    fill: "#C13925"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M957.292 303.401C957.292 300.89 953.817 298.855 949.532 298.855C945.247 298.855 941.772 300.89 941.772 303.401V308.856C941.772 311.366 945.247 313.402 949.532 313.402C953.817 313.402 957.292 311.366 957.292 308.856V303.401Z",
    fill: "#C13925"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M957.292 282.49C957.292 279.98 953.817 277.944 949.532 277.944C945.247 277.944 941.772 279.98 941.772 282.49V287.945C941.772 290.456 945.247 292.491 949.532 292.491C953.817 292.491 957.292 290.456 957.292 287.945V282.49Z",
    fill: "#C13925"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 970.871,
    cy: 292.491,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 928.193,
    cy: 292.491,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.532,
    cy: 303.401,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.532,
    cy: 282.49,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 246.174L992.106 267.142L949.532 289.934L906.959 267.142L949.532 246.174Z",
    fill: "#F3988B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M906.854 267.033L949.532 289.763V316.129L906.854 293.399V267.033Z",
    fill: "#EA7362"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M992.209 267.033L949.531 289.763V316.129L992.209 293.399V267.033Z",
    fill: "#C13925"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M978.63 264.306C978.63 261.796 975.156 259.76 970.871 259.76C966.585 259.76 963.111 261.796 963.111 264.306V269.761C963.111 272.271 966.585 274.307 970.871 274.307C975.156 274.307 978.63 272.271 978.63 269.761V264.306Z",
    fill: "#C13925"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M935.953 264.306C935.953 261.796 932.479 259.76 928.193 259.76C923.908 259.76 920.434 261.796 920.434 264.306V269.761C920.434 272.271 923.908 274.307 928.193 274.307C932.479 274.307 935.953 272.271 935.953 269.761V264.306Z",
    fill: "#C13925"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M957.292 275.216C957.292 272.706 953.817 270.67 949.532 270.67C945.247 270.67 941.772 272.706 941.772 275.216V280.671C941.772 283.182 945.247 285.217 949.532 285.217C953.817 285.217 957.292 283.182 957.292 280.671V275.216Z",
    fill: "#C13925"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M957.292 254.306C957.292 251.796 953.817 249.76 949.532 249.76C945.247 249.76 941.772 251.796 941.772 254.306V259.761C941.772 262.271 945.247 264.307 949.532 264.307C953.817 264.307 957.292 262.271 957.292 259.761V254.306Z",
    fill: "#C13925"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 970.871,
    cy: 264.306,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 928.193,
    cy: 264.306,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.532,
    cy: 275.217,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.532,
    cy: 254.305,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#F3988B"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 217.99L992.106 238.958L949.532 261.749L906.959 238.958L949.532 217.99Z",
    fill: "#A4D0DA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M906.854 238.849L949.532 261.578V287.944L906.854 265.215V238.849Z",
    fill: "#5CBCD1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M992.209 238.849L949.531 261.578V287.944L992.209 265.215V238.849Z",
    fill: "#33717F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M978.63 236.122C978.63 233.611 975.156 231.576 970.871 231.576C966.585 231.576 963.111 233.611 963.111 236.122V241.577C963.111 244.087 966.585 246.123 970.871 246.123C975.156 246.123 978.63 244.087 978.63 241.577V236.122Z",
    fill: "#33717F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M935.953 236.122C935.953 233.611 932.479 231.576 928.193 231.576C923.908 231.576 920.434 233.611 920.434 236.122V241.577C920.434 244.087 923.908 246.123 928.193 246.123C932.479 246.123 935.953 244.087 935.953 241.577V236.122Z",
    fill: "#33717F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M957.292 247.031C957.292 244.521 953.817 242.486 949.532 242.486C945.247 242.486 941.772 244.521 941.772 247.031V252.487C941.772 254.997 945.247 257.032 949.532 257.032C953.817 257.032 957.292 254.997 957.292 252.487V247.031Z",
    fill: "#33717F"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M957.292 226.121C957.292 223.611 953.817 221.576 949.532 221.576C945.247 221.576 941.772 223.611 941.772 226.121V231.576C941.772 234.087 945.247 236.122 949.532 236.122C953.817 236.122 957.292 234.087 957.292 231.576V226.121Z",
    fill: "#33717F"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 970.871,
    cy: 236.121,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#A4D0DA"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 928.193,
    cy: 236.121,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#A4D0DA"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.532,
    cy: 247.032,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#A4D0DA"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.532,
    cy: 226.121,
    rx: 6.7896,
    ry: 3.6367,
    fill: "#A4D0DA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.92 32.767L1082.08 32.6843V58.83L1039.4 81.3694L996.727 58.83V32.6843L996.883 32.767L1039.4 12L1081.92 32.767Z",
    fill: "#A4D0DA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M996.941 33.0151L1039.62 55.5545V81.7002L996.941 59.1608V33.0151Z",
    fill: "#5CBCD1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.3 33.0151L1039.62 55.5545V81.7002L1082.3 59.1608V33.0151Z",
    fill: "#33717F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M444.321 242.906L479.127 259.96L444.321 278.497L409.515 259.96L444.321 242.906Z",
    fill: "#A4D0DA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M409.515 259.96L444.321 278.497V300L409.515 281.463V259.96Z",
    fill: "#5CBCD1"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M479.128 259.96L444.322 278.497V300L479.128 281.463V259.96Z",
    fill: "#33717F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.199 218.902L479.403 200.056L514.655 217.418L479.403 236.29L479.267 236.223L444.065 254.971L408.726 236.151L444.065 218.836L444.199 218.902Z",
    fill: "#A4D0DA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.402 236.15L514.74 217.33V239.162L479.402 257.983V257.982L444.064 276.803V254.971L479.402 236.15V236.15Z",
    fill: "#33717F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M408.726 236.15L444.064 254.971V276.803L408.726 257.982V236.15Z",
    fill: "#5CBCD1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 189.806L992.106 210.774L949.532 233.565L906.959 210.774L949.532 189.806Z",
    fill: "#A4D0DA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M906.854 210.664L949.532 233.394V259.76L906.854 237.03V210.664Z",
    fill: "#5CBCD1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M992.209 210.664L949.531 233.394V259.76L992.209 237.03V210.664Z",
    fill: "#33717F"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 161.622L992.106 182.59L949.532 205.381L906.959 182.59L949.532 161.622Z",
    fill: "#A4D0DA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M906.854 182.48L949.532 205.21V231.576L906.854 208.846V182.48Z",
    fill: "#5CBCD1"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M992.209 182.48L949.531 205.21V231.576L992.209 208.846V182.48Z",
    fill: "#33717F"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M449.501 646.389L492.074 667.357L449.501 690.148L406.928 667.357L449.501 646.389Z",
    fill: "#F3988B"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M406.823 667.248L449.501 689.977V716.343L406.823 693.614V667.248Z",
    fill: "#EA7362"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M492.178 667.248L449.5 689.977V716.343L492.178 693.614V667.248Z",
    fill: "#C13925"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M449.501 618.204L492.074 639.172L449.501 661.964L406.928 639.172L449.501 618.204Z",
    fill: "#A4D0DA"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M406.823 639.063L449.501 661.792V688.158L406.823 665.429V639.063Z",
    fill: "#5CBCD1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M492.178 639.063L449.5 661.792V688.158L492.178 665.429V639.063Z",
    fill: "#33717F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M492.403 725.006L534.977 745.974L492.403 768.766L449.83 745.974L492.403 725.006Z",
    fill: "#A4D0DA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M449.726 745.865L492.403 768.595V794.961L449.726 772.231V745.865Z",
    fill: "#5CBCD1"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M535.08 745.865L492.403 768.595V794.961L535.08 772.231V745.865Z",
    fill: "#33717F"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M492.658 695.5L535.232 718.113L492.658 740.904L450.085 718.113L492.658 695.5Z",
    fill: "#F5C58A"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M449.98 718.003L492.658 740.733V767.099L449.98 744.369V718.003Z",
    fill: "#F1AE5B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M535.336 718.003L492.658 740.733V767.099L535.336 744.369V718.003Z",
    fill: "#D37D12"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.73 717.03L1104.4 739.759V766.125L1061.73 743.396V717.03Z",
    fill: "#EA7362"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.57 696.199L1147.08 673.439L1189.66 694.407L1147.08 717.198L1146.92 717.116L1104.4 739.759L1061.73 717.029L1104.4 696.118L1104.57 696.199Z",
    fill: "#F3988B"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.08 717.03L1189.76 694.3V720.666L1147.08 743.396V717.03ZM1104.4 739.759L1147.08 717.03V743.396L1104.4 766.125V739.759Z",
    fill: "#C13925"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M952.441 57.5326L909.764 78.4436L952.441 101.173L995.119 78.4436L952.441 57.5326Z",
    fill: "#F3988B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M909.764 78.4437L952.441 101.173V127.539L909.764 104.81V78.4437Z",
    fill: "#EA7362"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M995.122 34.8533L952.549 57.6445L995.122 78.6125L1037.7 55.8212L995.122 34.8533Z",
    fill: "#F3988B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M995.119 78.4437L1037.8 55.7144V82.0804L995.119 104.81V78.4437Z",
    fill: "#C13925"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M952.441 101.173L995.119 78.4437V104.81L952.441 127.539V101.173Z",
    fill: "#C13925"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M772.403 37.1447L814.977 58.1127L772.403 80.9039L729.83 58.1127L772.403 37.1447Z",
    fill: "#A4D0DA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M729.726 58.0033L772.403 80.7326V107.099L729.726 84.3693V58.0033Z",
    fill: "#5CBCD1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M815.08 58.0033L772.403 80.7326V107.099L815.08 84.3693V58.0033Z",
    fill: "#33717F"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M903.945 105.81L861.268 128.54V154.906L903.945 132.176V105.81Z",
    fill: "#D37D12"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.103 84.9791L818.588 62.2192L776.015 83.1872L818.588 105.978L818.754 105.897L861.267 128.539L903.945 105.81L861.267 84.8987L861.103 84.9791Z",
    fill: "#F5C58A"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M818.59 105.81L775.912 83.0807V109.447L818.59 132.176V105.81ZM861.267 128.54L818.59 105.81V132.176L861.267 154.906V128.54Z",
    fill: "#F1AE5B"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.08 35.2894L796.403 22.6782L753.726 43.5892L777.403 56.2006L777.403 56.2004L820.08 78.9295L862.757 56.2002L820.08 35.2892L820.08 35.2894Z",
    fill: "#6DD6B0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M777.403 56.2003L754.226 44.0552V70.4212L777.402 82.5662V82.567L820.08 105.296V78.9303L777.403 56.2012V56.2003Z",
    fill: "#52BDA4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M862.758 56.2009L820.08 78.9303V105.296L862.758 82.567V56.2009Z",
    fill: "#338177"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949.367 132.256L906.852 109.496L864.278 130.464L906.852 153.255L907.018 153.173L949.533 175.816L992.21 153.086L949.533 132.175L949.367 132.256Z",
    fill: "#D0AFC8"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.854 153.087L864.177 130.357V156.723L906.854 179.453V153.087ZM949.532 175.816L906.854 153.086V179.452L949.532 202.182V175.816Z",
    fill: "#AA6F9C"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M992.209 153.086L949.531 175.816V202.182L992.209 179.452V153.086Z",
    fill: "#704265"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M675.383 46.0473L675.527 45.9709V70.1224L636.105 90.9426L596.683 70.1224V45.9709L596.827 46.0473L636.105 26.8643L675.383 46.0473Z",
    fill: "#F3988B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M596.881 46.2765L636.303 67.0967V91.2482L596.881 70.428V46.2765Z",
    fill: "#EA7362"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M675.727 46.2765L636.304 67.0967V91.2482L675.727 70.428V46.2765Z",
    fill: "#C13925"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M675.383 20.1831L675.527 20.1066V44.2581L636.105 65.0783L596.683 44.2581V20.1066L596.827 20.1831L636.105 1L675.383 20.1831Z",
    fill: "#F3988B"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M596.881 20.4122L636.303 41.2325V65.384L596.881 44.5637V20.4122Z",
    fill: "#EA7362"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M675.727 20.4121L636.304 41.2324V65.3838L675.727 44.5636V20.4121Z",
    fill: "#C13925"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M282.284 27.4006L282.432 27.3222V52.0813L242.018 73.4254L201.604 52.0813V27.3222L201.752 27.4006L242.018 7.73486L282.284 27.4006Z",
    fill: "#F3988B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M201.808 27.6356L242.222 48.9797V73.7388L201.808 52.3947V27.6356Z",
    fill: "#EA7362"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M282.637 27.6356L242.223 48.9797V73.7388L282.637 52.3947V27.6356Z",
    fill: "#C13925"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M240.144 49.6618L240.292 49.5835V74.3426L199.878 95.6866L119.347 53.1067V28.3476L159.612 8.68188L240.144 49.6618Z",
    fill: "#D0AFC8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M119.218 28.0935L200.081 71.2409V96L119.218 52.8526V28.0935Z",
    fill: "#AA6F9C"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M240.495 49.8966L200.081 71.2407V95.9998L240.495 74.6557V49.8966Z",
    fill: "#704265"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M611.183 53.9063L611.328 53.8299V77.9814L571.906 98.8016L493.351 57.2667V33.1152L532.628 13.9321L611.183 53.9063Z",
    fill: "#6DD6B0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M493.226 32.8674L572.105 74.9559V99.1074L493.226 57.0189V32.8674Z",
    fill: "#52BDA4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M611.526 54.1355L572.104 74.9557V99.1072L611.526 78.287V54.1355Z",
    fill: "#338177"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M159.652 49.6618L159.8 49.5835V74.3426L119.386 95.6866L38.8545 53.1067V28.3476L79.1203 8.68188L159.652 49.6618Z",
    fill: "#6DD6B0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7256 28.0935L119.589 71.2409V96L38.7256 52.8526V28.0935Z",
    fill: "#52BDA4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M160.003 49.8966L119.589 71.2407V95.9998L160.003 74.6557V49.8966Z",
    fill: "#338177"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M611.466 28.4965L611.61 28.4201V52.5716L572.188 73.3918L532.766 52.5716V28.4201L532.91 28.4965L572.188 9.31348L611.466 28.4965Z",
    fill: "#F5C58A"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M532.964 28.7257L572.386 49.546V73.6974L532.964 52.8772V28.7257Z",
    fill: "#F1AE5B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M611.809 28.7257L572.386 49.546V73.6974L611.809 52.8772V28.7257Z",
    fill: "#D37D12"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M160.125 22.6657L160.274 22.5873V47.3464L119.859 68.6905L79.4453 47.3464V22.5873L79.5937 22.6657L119.859 3L160.125 22.6657Z",
    fill: "#F5C58A"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6484 22.9006L120.063 44.2447V69.0038L79.6484 47.6598V22.9006Z",
    fill: "#F1AE5B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M160.478 22.9006L120.063 44.2447V69.0038L160.478 47.6598V22.9006Z",
    fill: "#D37D12"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.899 726.945L704.383 704.185L661.81 725.153L704.383 747.944L704.55 747.862L747.064 770.504L789.741 747.775L747.064 726.864L746.899 726.945Z",
    fill: "#6DD6B0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M704.386 747.775L747.063 770.504V796.87L704.386 774.141V747.775Z",
    fill: "#52BDA4"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M661.708 725.046L704.385 747.775V774.141L661.708 751.412V725.046Z",
    fill: "#52BDA4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M789.74 747.775L747.063 770.504V796.87L789.74 774.141V747.775Z",
    fill: "#338177"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M907.824 81.2614L950.502 102.172L907.824 124.902L865.147 102.172L907.824 81.2614Z",
    fill: "#D0AFC8"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M865.145 58.5821L907.719 81.3734L865.145 102.341L822.572 79.5501L865.145 58.5821Z",
    fill: "#D0AFC8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M865.147 102.173L907.825 124.902V151.268L865.147 128.539V102.173Z",
    fill: "#AA6F9C"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M822.47 79.4432L865.147 102.173V128.539L822.47 105.809V79.4432Z",
    fill: "#AA6F9C"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M950.502 102.173L907.824 124.902V151.268L950.502 128.539V102.173Z",
    fill: "#704265"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M330.08 520.912L372.758 541.823L330.08 564.553L287.403 541.823L330.08 520.912Z",
    fill: "#D0AFC8"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M287.401 498.233L329.975 521.024L287.401 541.992L244.828 519.201L287.401 498.233Z",
    fill: "#D0AFC8"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M287.403 541.824L330.081 564.553V590.919L287.403 568.19V541.824Z",
    fill: "#AA6F9C"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M244.726 519.094L287.403 541.824V568.19L244.726 545.46V519.094Z",
    fill: "#AA6F9C"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M372.758 541.824L330.08 564.553V590.919L372.758 568.19V541.824Z",
    fill: "#704265"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.542 727.853L619.028 705.093L576.454 726.061L619.028 748.853L619.193 748.771L661.706 771.413L704.384 748.683L661.706 727.772L661.542 727.853Z",
    fill: "#D0AFC8"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.029 748.684L576.352 725.955V752.321L619.029 775.05V748.684ZM661.707 771.413L619.029 748.684V775.05L661.707 797.779V771.413Z",
    fill: "#AA6F9C"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M704.385 748.684L661.707 771.413V797.779L704.385 775.05V748.684Z",
    fill: "#704265"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M572.474 726.916L615.047 747.884L572.474 770.675L529.9 747.884L572.474 726.916Z",
    fill: "#F3988B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M529.796 747.775L572.473 770.504V796.87L529.796 774.141V747.775Z",
    fill: "#EA7362"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M615.15 747.775L572.473 770.504V796.87L615.15 774.141V747.775Z",
    fill: "#C13925"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M514.531 241.366L479.725 258.421L514.531 276.958L549.337 258.421L514.531 241.366Z",
    fill: "#F5C58A"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M549.339 258.421L514.533 276.958V298.461L549.339 279.924V258.421Z",
    fill: "#D37D12"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M479.728 258.421L514.533 276.958V298.461L479.728 279.924V258.421Z",
    fill: "#F1AE5B"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M549.341 222.87L514.62 241.458L549.341 258.558L584.062 239.971L549.341 222.87Z",
    fill: "#F5C58A"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M584.145 239.884L549.339 258.421V279.924L584.145 261.387V239.884Z",
    fill: "#D37D12"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M549.531 200.857L584.252 217.958L549.531 236.545L514.81 217.958L549.531 200.857Z",
    fill: "#D0AFC8"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M514.726 217.868L549.531 236.405V257.908L514.726 239.371V217.868Z",
    fill: "#AA6F9C"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M584.339 217.868L549.533 236.405V257.908L584.339 239.371V217.868Z",
    fill: "#704265"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 646.195L1189.65 667.163L1147.08 689.955L1104.51 667.163L1147.08 646.195Z",
    fill: "#F5C58A"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 667.055L1147.08 689.784V716.15L1104.4 693.421V667.055Z",
    fill: "#F1AE5B"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 667.055L1147.08 689.784V716.15L1189.76 693.421V667.055Z",
    fill: "#D37D12"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 649.787L93.9768 670.755L51.4033 693.546L8.82985 670.755L51.4033 649.787Z",
    fill: "#F5C58A"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 670.646L51.4031 693.376V719.742L8.72559 697.012V670.646Z",
    fill: "#F1AE5B"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 670.646L51.4026 693.376V719.742L94.0801 697.012V670.646Z",
    fill: "#D37D12"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 618.011L1189.65 638.979L1147.08 661.771L1104.51 638.979L1147.08 618.011Z",
    fill: "#F5C58A"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 638.87L1147.08 661.6V687.966L1104.4 665.236V638.87Z",
    fill: "#F1AE5B"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 638.87L1147.08 661.6V687.966L1189.76 665.236V638.87Z",
    fill: "#D37D12"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 621.603L93.9768 642.571L51.4033 665.362L8.82985 642.571L51.4033 621.603Z",
    fill: "#F5C58A"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 642.462L51.4031 665.191V691.557L8.72559 668.828V642.462Z",
    fill: "#F1AE5B"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 642.462L51.4026 665.191V691.557L94.0801 668.828V642.462Z",
    fill: "#D37D12"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 589.827L1189.65 610.795L1147.08 633.586L1104.51 610.795L1147.08 589.827Z",
    fill: "#F5C58A"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 610.686L1147.08 633.415V659.781L1104.4 637.052V610.686Z",
    fill: "#F1AE5B"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 610.686L1147.08 633.415V659.781L1189.76 637.052V610.686Z",
    fill: "#D37D12"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 593.418L93.9768 614.386L51.4033 637.177L8.82985 614.386L51.4033 593.418Z",
    fill: "#F5C58A"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 614.277L51.4031 637.006V663.372L8.72559 640.643V614.277Z",
    fill: "#F1AE5B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 614.277L51.4026 637.006V663.372L94.0801 640.643V614.277Z",
    fill: "#D37D12"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 561.643L1189.65 582.611L1147.08 605.402L1104.51 582.611L1147.08 561.643Z",
    fill: "#6DD6B0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 582.501L1147.08 605.231V631.597L1104.4 608.868V582.501Z",
    fill: "#52BDA4"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 582.501L1147.08 605.231V631.597L1189.76 608.868V582.501Z",
    fill: "#338177"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 565.234L93.9768 586.202L51.4033 608.993L8.82985 586.202L51.4033 565.234Z",
    fill: "#6DD6B0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 586.092L51.4031 608.822V635.188L8.72559 612.458V586.092Z",
    fill: "#52BDA4"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 586.092L51.4026 608.822V635.188L94.0801 612.458V586.092Z",
    fill: "#338177"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 533.458L1189.65 554.426L1147.08 577.217L1104.51 554.426L1147.08 533.458Z",
    fill: "#6DD6B0"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 554.317L1147.08 577.046V603.412L1104.4 580.683V554.317Z",
    fill: "#52BDA4"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 554.317L1147.08 577.046V603.412L1189.76 580.683V554.317Z",
    fill: "#338177"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 537.05L93.9768 558.018L51.4033 580.81L8.82985 558.018L51.4033 537.05Z",
    fill: "#6DD6B0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 557.909L51.4031 580.638V607.004L8.72559 584.275V557.909Z",
    fill: "#52BDA4"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 557.909L51.4026 580.638V607.004L94.0801 584.275V557.909Z",
    fill: "#338177"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 505.275L1189.65 526.243L1147.08 549.034L1104.51 526.243L1147.08 505.275Z",
    fill: "#A4D0DA"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 526.133L1147.08 548.863V575.229L1104.4 552.499V526.133Z",
    fill: "#5CBCD1"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 526.133L1147.08 548.863V575.229L1189.76 552.499V526.133Z",
    fill: "#33717F"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 508.866L93.9768 529.834L51.4033 552.626L8.82985 529.834L51.4033 508.866Z",
    fill: "#A4D0DA"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 529.725L51.4031 552.454V578.82L8.72559 556.091V529.725Z",
    fill: "#5CBCD1"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 529.725L51.4026 552.454V578.82L94.0801 556.091V529.725Z",
    fill: "#33717F"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 477.09L1189.65 498.058L1147.08 520.849L1104.51 498.058L1147.08 477.09Z",
    fill: "#D0AFC8"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 497.948L1147.08 520.677V547.043L1104.4 524.314V497.948Z",
    fill: "#AA6F9C"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 497.948L1147.08 520.677V547.043L1189.76 524.314V497.948Z",
    fill: "#704265"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 480.681L93.9768 501.649L51.4033 524.441L8.82985 501.649L51.4033 480.681Z",
    fill: "#D0AFC8"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 501.54L51.4031 524.269V550.635L8.72559 527.906V501.54Z",
    fill: "#AA6F9C"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 501.54L51.4026 524.269V550.635L94.0801 527.906V501.54Z",
    fill: "#704265"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 448.906L1189.65 469.874L1147.08 492.665L1104.51 469.874L1147.08 448.906Z",
    fill: "#D0AFC8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 469.764L1147.08 492.494V518.86L1104.4 496.13V469.764Z",
    fill: "#AA6F9C"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 469.764L1147.08 492.494V518.86L1189.76 496.13V469.764Z",
    fill: "#704265"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 452.497L93.9768 473.465L51.4033 496.256L8.82985 473.465L51.4033 452.497Z",
    fill: "#D0AFC8"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 473.355L51.4031 496.085V522.451L8.72559 499.721V473.355Z",
    fill: "#AA6F9C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 473.355L51.4026 496.085V522.451L94.0801 499.721V473.355Z",
    fill: "#704265"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 420.721L1189.65 441.689L1147.08 464.481L1104.51 441.689L1147.08 420.721Z",
    fill: "#F3988B"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 441.58L1147.08 464.309V490.675L1104.4 467.946V441.58Z",
    fill: "#EA7362"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 441.58L1147.08 464.309V490.675L1189.76 467.946V441.58Z",
    fill: "#C13925"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 424.312L93.9768 445.28L51.4033 468.071L8.82985 445.28L51.4033 424.312Z",
    fill: "#F3988B"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 445.171L51.4031 467.9V494.266L8.72559 471.537V445.171Z",
    fill: "#EA7362"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 445.171L51.4026 467.9V494.266L94.0801 471.537V445.171Z",
    fill: "#C13925"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 392.536L1189.65 413.504L1147.08 436.295L1104.51 413.504L1147.08 392.536Z",
    fill: "#F3988B"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 413.395L1147.08 436.125V462.491L1104.4 439.761V413.395Z",
    fill: "#EA7362"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 413.395L1147.08 436.125V462.491L1189.76 439.761V413.395Z",
    fill: "#C13925"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 396.128L93.9768 417.096L51.4033 439.887L8.82985 417.096L51.4033 396.128Z",
    fill: "#F3988B"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 416.986L51.4031 439.715V466.081L8.72559 443.352V416.986Z",
    fill: "#EA7362"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 416.986L51.4026 439.715V466.081L94.0801 443.352V416.986Z",
    fill: "#C13925"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 364.352L1189.65 385.32L1147.08 408.111L1104.51 385.32L1147.08 364.352Z",
    fill: "#F3988B"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 385.211L1147.08 407.94V434.306L1104.4 411.577V385.211Z",
    fill: "#EA7362"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 385.211L1147.08 407.94V434.306L1189.76 411.577V385.211Z",
    fill: "#C13925"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 367.943L93.9768 388.911L51.4033 411.702L8.82985 388.911L51.4033 367.943Z",
    fill: "#F3988B"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 388.802L51.4031 411.531V437.897L8.72559 415.168V388.802Z",
    fill: "#EA7362"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 388.802L51.4026 411.531V437.897L94.0801 415.168V388.802Z",
    fill: "#C13925"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 336.168L1189.65 357.136L1147.08 379.927L1104.51 357.136L1147.08 336.168Z",
    fill: "#A4D0DA"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 357.026L1147.08 379.756V406.122L1104.4 383.392V357.026Z",
    fill: "#5CBCD1"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 357.026L1147.08 379.756V406.122L1189.76 383.392V357.026Z",
    fill: "#33717F"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 339.759L93.9768 360.727L51.4033 383.519L8.82985 360.727L51.4033 339.759Z",
    fill: "#A4D0DA"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 360.618L51.4031 383.348V409.714L8.72559 386.984V360.618Z",
    fill: "#5CBCD1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 360.618L51.4026 383.348V409.714L94.0801 386.984V360.618Z",
    fill: "#33717F"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 307.983L1189.65 328.951L1147.08 351.742L1104.51 328.951L1147.08 307.983Z",
    fill: "#F5C58A"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 328.842L1147.08 351.571V377.937L1104.4 355.208V328.842Z",
    fill: "#F1AE5B"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 328.842L1147.08 351.571V377.937L1189.76 355.208V328.842Z",
    fill: "#D37D12"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 279.727L1189.65 300.695L1147.08 323.487L1104.51 300.695L1147.08 279.727Z",
    fill: "#F5C58A"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 300.586L1147.08 323.315V349.681L1104.4 326.952V300.586Z",
    fill: "#F1AE5B"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 300.586L1147.08 323.315V349.681L1189.76 326.952V300.586Z",
    fill: "#D37D12"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 311.574L93.9768 332.542L51.4033 355.334L8.82985 332.542L51.4033 311.574Z",
    fill: "#F5C58A"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 332.433L51.4031 355.163V381.529L8.72559 358.799V332.433Z",
    fill: "#F1AE5B"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 332.433L51.4026 355.163V381.529L94.0801 358.799V332.433Z",
    fill: "#D37D12"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 283.419L93.9768 304.387L51.4033 327.178L8.82985 304.387L51.4033 283.419Z",
    fill: "#F5C58A"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 304.277L51.4031 327.007V353.373L8.72559 330.643V304.277Z",
    fill: "#F1AE5B"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 304.277L51.4026 327.007V353.373L94.0801 330.643V304.277Z",
    fill: "#D37D12"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 250.705L1189.65 271.673L1147.08 294.464L1104.51 271.673L1147.08 250.705Z",
    fill: "#D0AFC8"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 271.563L1147.08 294.293V320.659L1104.4 297.93V271.563Z",
    fill: "#AA6F9C"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 271.563L1147.08 294.293V320.659L1189.76 297.93V271.563Z",
    fill: "#704265"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 255.234L93.9768 276.202L51.4033 298.993L8.82985 276.202L51.4033 255.234Z",
    fill: "#D0AFC8"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 276.093L51.4031 298.822V325.188L8.72559 302.459V276.093Z",
    fill: "#AA6F9C"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 276.093L51.4026 298.822V325.188L94.0801 302.459V276.093Z",
    fill: "#704265"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 222.549L1189.65 243.517L1147.08 266.308L1104.51 243.517L1147.08 222.549Z",
    fill: "#D0AFC8"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.4 243.408L1147.08 266.137V292.503L1104.4 269.774V243.408Z",
    fill: "#AA6F9C"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 243.408L1147.08 266.137V292.503L1189.76 269.774V243.408Z",
    fill: "#704265"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4033 227.078L93.9768 248.046L51.4033 270.837L8.82985 248.046L51.4033 227.078Z",
    fill: "#D0AFC8"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 247.937L51.4031 270.666V297.032L8.72559 274.303V247.937Z",
    fill: "#AA6F9C"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0801 247.937L51.4026 270.666V297.032L94.0801 274.303V247.937Z",
    fill: "#704265"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M252.403 525.145L294.977 546.113L252.403 568.904L209.83 546.113L252.403 525.145Z",
    fill: "#D0AFC8"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M209.726 546.003L252.403 568.733V595.099L209.726 572.369V546.003Z",
    fill: "#AA6F9C"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M295.08 546.003L252.403 568.733V595.099L295.08 572.369V546.003Z",
    fill: "#704265"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M252.403 497.145L294.977 518.113L252.403 540.904L209.83 518.113L252.403 497.145Z",
    fill: "#D0AFC8"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M209.726 518.003L252.403 540.733V567.099L209.726 544.369V518.003Z",
    fill: "#AA6F9C"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M295.08 518.003L252.403 540.733V567.099L295.08 544.369V518.003Z",
    fill: "#704265"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 469.589L294.395 490.557L251.821 513.348L209.248 490.557L251.821 469.589Z",
    fill: "#6DD6B0"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 490.448L251.821 513.177V539.543L209.144 516.814V490.448Z",
    fill: "#52BDA4"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 490.448L251.821 513.177V539.543L294.498 516.814V490.448Z",
    fill: "#338177"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 441.404L294.395 462.372L251.821 485.163L209.248 462.372L251.821 441.404Z",
    fill: "#6DD6B0"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 462.263L251.821 484.992V511.358L209.144 488.629V462.263Z",
    fill: "#52BDA4"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 462.263L251.821 484.992V511.358L294.498 488.629V462.263Z",
    fill: "#338177"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 413.22L294.395 434.188L251.821 456.98L209.248 434.188L251.821 413.22Z",
    fill: "#A4D0DA"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 434.079L251.821 456.808V483.174L209.144 460.445V434.079Z",
    fill: "#5CBCD1"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 434.079L251.821 456.808V483.174L294.498 460.445V434.079Z",
    fill: "#33717F"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 384.099L294.395 405.067L251.821 427.858L209.248 405.067L251.821 384.099Z",
    fill: "#D0AFC8"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 404.958L251.821 427.687V454.053L209.144 431.324V404.958Z",
    fill: "#AA6F9C"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 404.958L251.821 427.687V454.053L294.498 431.324V404.958Z",
    fill: "#704265"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 355.914L294.395 376.882L251.821 399.673L209.248 376.882L251.821 355.914Z",
    fill: "#D0AFC8"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 376.773L251.821 399.502V425.868L209.144 403.139V376.773Z",
    fill: "#AA6F9C"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 376.773L251.821 399.502V425.868L294.498 403.139V376.773Z",
    fill: "#704265"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 327.73L294.395 348.698L251.821 371.489L209.248 348.698L251.821 327.73Z",
    fill: "#F3988B"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 348.588L251.821 371.318V397.684L209.144 374.954V348.588Z",
    fill: "#EA7362"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 348.588L251.821 371.318V397.684L294.498 374.954V348.588Z",
    fill: "#C13925"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 299.545L294.395 320.513L251.821 343.304L209.248 320.513L251.821 299.545Z",
    fill: "#F3988B"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 320.404L251.821 343.133V369.499L209.144 346.77V320.404Z",
    fill: "#EA7362"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 320.404L251.821 343.133V369.499L294.498 346.77V320.404Z",
    fill: "#C13925"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 271.361L294.395 292.329L251.821 315.12L209.248 292.329L251.821 271.361Z",
    fill: "#F3988B"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 292.22L251.821 314.949V341.315L209.144 318.586V292.22Z",
    fill: "#EA7362"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 292.22L251.821 314.949V341.315L294.498 318.586V292.22Z",
    fill: "#C13925"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 243.176L294.395 264.144L251.821 286.936L209.248 264.144L251.821 243.176Z",
    fill: "#A4D0DA"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 264.035L251.821 286.764V313.13L209.144 290.401V264.035Z",
    fill: "#5CBCD1"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 264.035L251.821 286.764V313.13L294.498 290.401V264.035Z",
    fill: "#33717F"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M251.821 215.02L294.395 235.988L251.821 258.779L209.248 235.988L251.821 215.02Z",
    fill: "#F5C58A"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M209.144 235.879L251.821 258.608V284.974L209.144 262.245V235.879Z",
    fill: "#F1AE5B"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M294.498 235.879L251.821 258.608V284.974L294.498 262.245V235.879Z",
    fill: "#D37D12"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M886.924 40.767L887.081 40.6843V66.83L844.403 89.3694L801.726 66.83V40.6843L801.882 40.767L844.403 20L886.924 40.767Z",
    fill: "#A4D0DA"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M801.94 41.0151L844.618 63.5545V89.7002L801.94 67.1608V41.0151Z",
    fill: "#5CBCD1"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M887.295 41.0151L844.617 63.5545V89.7002L887.295 67.1608V41.0151Z",
    fill: "#33717F"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M864.727 74.9465L907.404 97.6759V124.042L864.727 101.313V74.9465Z",
    fill: "#F1AE5B"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.568 54.1161L950.084 31.3555L992.657 52.3234L950.084 75.1147L949.918 75.033L907.403 97.6758L864.725 74.9464L907.403 54.0354L907.568 54.1161Z",
    fill: "#F5C58A"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M950.081 74.9466L992.759 52.2173V78.5833L950.081 101.313V74.9466ZM907.404 97.6759L950.081 74.9465V101.313L907.404 124.042V97.6759Z",
    fill: "#D37D12"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M517.426 46.0473L517.57 45.9709V70.1224L478.148 90.9426L438.726 70.1224V45.9709L438.87 46.0473L478.148 26.8643L517.426 46.0473Z",
    fill: "#F3988B"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M438.924 46.2765L478.346 67.0967V91.2482L438.924 70.428V46.2765Z",
    fill: "#EA7362"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M517.77 46.2765L478.347 67.0967V91.2482L517.77 70.428V46.2765Z",
    fill: "#C13925"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M616.403 700.145L658.977 721.113L616.403 743.904L573.83 721.113L616.403 700.145Z",
    fill: "#F3988B"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M573.726 721.003L616.403 743.733V770.099L573.726 747.37V721.003Z",
    fill: "#EA7362"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M659.08 721.003L616.403 743.733V770.099L659.08 747.37V721.003Z",
    fill: "#C13925"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarbleWorld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MarbleWorld.8863b3ab211e2b07c1039c817d7fca74.svg";